const initialDashboard = {
    dashboardData: [],
    loadingDashboard: false,
    errorsDashboard: {},
    monthlyReportList: [],
    loadingMonthlyReport: false,
    errorsMonthlyReport: null
}

const dashboardReducer = (dashboard = initialDashboard, action) => {
    switch (action.type) {
        case "GET_DASHBOARD_DATA_PENDING":
            return { ...dashboard, loadingDashboard: true };

        case "GET_DASHBOARD_DATA_FULFILLED":
            return {
                ...dashboard,
                loadingDashboard: false,
                dashboardData: action.payload,
            };

        case "GET_DASHBOARD_DATA_REJECTED":
            return {
                ...dashboard,
                loadingDashboard: false,
                errorsDashboard: action.payload
            };

        case "GET_MONTHLY_REPORT_PENDING":
            return { ...dashboard, loadingMonthlyReport: true, errorsMonthlyReport: null };

        case "GET_MONTHLY_REPORT_FULFILLED":
            return {
                ...dashboard,
                loadingMonthlyReport: false,
                monthlyReportList: Array.isArray(action.payload) ? action.payload : [],
                errorsMonthlyReport: null
            };

        case "GET_MONTHLY_REPORT_REJECTED":
            return {
                ...dashboard,
                loadingMonthlyReport: false,
                monthlyReportList: [],
                errorsMonthlyReport: action.payload
            };

        default:
            return dashboard;
    }
}

export default dashboardReducer;